import script from "./DailyAssignedFollowupsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyAssignedFollowupsChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyAssignedFollowupsChart.vue?vue&type=style&index=0&id=2df90c40&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df90c40"]])

export default __exports__